import { render, staticRenderFns } from "./digitalSurvey.vue?vue&type=template&id=2f18ce78&scoped=true&"
import script from "./digitalSurvey.vue?vue&type=script&lang=js&"
export * from "./digitalSurvey.vue?vue&type=script&lang=js&"
import style0 from "./digitalSurvey.vue?vue&type=style&index=0&id=2f18ce78&prod&lang=scss&"
import style1 from "./digitalSurvey.vue?vue&type=style&index=1&id=2f18ce78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f18ce78",
  null
  
)

export default component.exports